import formatDate from "../../utils/dateFormat.utils";

var d = new Date();

const DateInitialState = {
  date: formatDate(d),
};

export default DateInitialState;
